import { Colors } from '../../themes/colors';

export const BriefcaseIcon = ({ color = Colors.neutral_600 }) => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.5 13.2554C18.7207 14.3805 15.6827 15 12.5 15C9.3173 15 6.2793 14.3805 3.5 13.2554M16.5 6V4C16.5 2.89543 15.6046 2 14.5 2H10.5C9.39543 2 8.5 2.89543 8.5 4V6M12.5 12H12.51M5.5 20H19.5C20.6046 20 21.5 19.1046 21.5 18V8C21.5 6.89543 20.6046 6 19.5 6H5.5C4.39543 6 3.5 6.89543 3.5 8V18C3.5 19.1046 4.39543 20 5.5 20Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
